module.exports = __webpack_public_path__ + "static/img/a036.5fe3bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a036.jpg
// module id = kfFs
// module chunks = 0